var map = {
	"./bn_bd.json": "a31a",
	"./en.json": "e312",
	"./id_id.json": "71a7",
	"./ja_jp.json": "a81e",
	"./km_kh.json": "f1c9",
	"./ko_kr.json": "0bc8",
	"./my_mm.json": "4992",
	"./pt_br.json": "597c",
	"./th_th.json": "d836",
	"./vi_vn.json": "93d1",
	"./zh_cn.json": "fc70",
	"./zh_tw.json": "224c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";